import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '*',
      redirect: '/'
    }, 
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home',
          meta:{index:0},
        }, 
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '北京芯能电子科技有限公司官网',
            index:0
          }
        }, 
        {
          path: '/company',
          name: 'company',   
          redirect: '/company/info', 
          children: [],
          meta:{index:1},
        }, 
        {
          path: '/company/info',  
          name: 'companyinfo',          
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '北京芯能 | 公司简介',
            index:1
          },
        },
        {
          path: '/company/time',
          name: 'companytime',
          component: resolve => require(['@/view/CompanyTime'], resolve),
          meta: {
            title: '北京芯能 | 公司沿革',
            index:1
          }
        },
        {
          path: '/company/factory',
          name: 'CompanyFactory',
          component: resolve => require(['@/view/CompanyFactory'], resolve),
          meta: {
            title: '北京芯能 | 工厂介绍',
            index:1
          }
        },
        {
          path: '/company/news',
          name: 'companynews',
          component: resolve => require(['@/view/CompanyNews'], resolve),
          meta: {
            title: '北京芯能 | 公司新闻',
            index:2
          }
        },
        {
          path: '/dynamics',
          name: 'dynamics',
          component: resolve => require(['@/view/Dynamics'], resolve),
          meta: {
            title: '北京芯能 | 行业动态',
            index:2
          }
        },
        {
          path: '/job',
          name: 'job',   
          redirect: '/job/fair', 
          children: [ ]
        }, 
        {
          path: '/job/fair',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '北京芯能 | 社会招聘',
            index:4
          }
        }, 
        {
          path: '/job/campusrecruitment',
          name: 'JobStatudent',
          component: resolve => require(['@/view/JobStatudent'], resolve),
          meta: {
            title: '北京芯能 | 校园招聘',
            index:4
          }
        }, 
        {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '北京芯能 | 联系方式',
            index:5
          }
        },
        {
          path: '/ContactForm',
          name: 'ContactForm',
          component: resolve => require(['@/view/ContactForm'], resolve),
          meta: {
            title: '北京芯能 | 技术咨询',
            index:5
          }
        },
        {
          path: '/ContactForm2',
          name: 'ContactForm2',
          component: resolve => require(['@/view/ContactForm2'], resolve),
          meta: {
            title: '北京芯能 | 样品申请',
            index:5
          }
        },
        {
          path: '/product',
          name: 'product',
          component: resolve => require(['@/view/Product'], resolve),
          meta: {
            title: '北京芯能 | 产品系列',
            index:3
          }
        },
        {
          path: '/newsdetail',
          name: 'newsdetail',
          component: resolve => require(['@/view/NewsDetai'], resolve),
          meta: {
            title: '北京芯能 | 新闻详情',
            index:2
          }
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js